export default {
  namespace: true,
  state: {
    // array of breadcrumb objects, in the form of VueRouter
    // descriptors (see https://router.vuejs.org/api/#to)
    title: '',
  },
  getters: {
    get: (state) => state.title,
  },
  mutations: {
    set(state, title) {
      state.title = title;
    },
    empty(state) {
      state.title = [];
    },
  },
};
